import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import api from "./api";
import { AppThunk } from "./app";
import API_URL from "../config/ApiUrl";

interface SendMessageState {
  status: [];
  privilegesList: [];
  rolesList: [];
}

const initialState = {
  status: [],
  // privilegesList: [],
  // rolesList: [],
} as SendMessageState;

const SendMessageSlice = createSlice({
  name: "SendMessage",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
    // setPrivilegesList: (state, action: PayloadAction<any>) => {
    //   state.privilegesList = action.payload;
    // },
    // setRolesList: (state, action: PayloadAction<any>) => {
    //   state.rolesList = action.payload;
    // },
  },
});

export const { setStatus } = SendMessageSlice.actions;

export const fetchCheckAction =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.SEND_MESSAGE.CHECK, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchInquireNumberAction =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.INQUIRE_NUMBER.ADD, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchPublish =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.PUBLISH.ADD, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchAddPortabilityNumber =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.ADD_PORTABILITY_NUMBER.ADD, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const fetchAddPortabilityNumberList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.ADD_PORTABILITY_NUMBER.LIST, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

// for Aesterisk Apis starts from here...

export const fetchInquireNumber =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.ASTERISK.ADD, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const updateInquireNumber =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.ASTERISK.UPDATE, payload);

      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const checkAesteriskNumber =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const action = payload.action ? payload.action : "asterisk_number";
      const number = payload.number ? payload.number : "";

      const act = `?action=${action}&number=${number}`;

      const response = await api.get(API_URL.ASTERISK.CHECK + act);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchInquireNumberList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const request_id = payload.request_id ? payload.request_id : "";
      const number = payload.number ? payload.number : "";
      const current = payload.current ? payload.current : 1;
      const page_size = payload.page_size ? payload.page_size : 10;

      const action = `?request_id=${request_id}&number=${number}&current=${current}&page_size=${page_size}`;

      const response = await api.get(API_URL.INQUIRE_NUMBER.LIST + action);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const fetchInquireNumberReportList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.INQUIRE_NUMBER.REPORTS, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchPublishList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const request_id = payload.request_id ? payload.request_id : "";
      const number = payload.number ? payload.number : "";
      const current = payload.current ? payload.current : 1;
      const page_size = payload.page_size ? payload.page_size : 10;

      const action = `?request_id=${request_id}&number=${number}&current=${current}&page_size=${page_size}`;

      const response = await api.get(API_URL.PUBLISH.LIST + action);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListMonitor =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.SEND_MESSAGE.LIST, payload);
      return Promise.resolve(response.data.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchDeleteMonitorList =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.SEND_MESSAGE.DELETE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const updatePortTimeRequest =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.SEND_MESSAGE.UPDATE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const cancelPortTimeRequest =
  (actionData?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const payload = {
        request_id: actionData?.request_id,
      };
      const response = await api.post(API_URL.SEND_MESSAGE.CANCEL, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const handlePortReturnRequest =
  (actionData?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.SEND_MESSAGE.RETURN, actionData);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const deletePortTimeRequest =
  (actionData?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const payload = {
        request_id: actionData?.request_id,
      };
      const response = await api.post(API_URL.INQUIRE_NUMBER.DELETE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const getProviderListCode = (): AppThunk<any> => async () => {
  try {
    const response = await api.get(API_URL.PROVIDER.LIST_WITH_CODE);
    return Promise.resolve(response.data);
  } catch (error: any) {
    return Promise.reject(error.data);
  }
};

export const updateEmails =
  (payload: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.SEND_MESSAGE.UPDATE_EMAIL, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const getReport =
  (payload: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.PROVIDER.REPORT, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const getPublishReport =
  (payload: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.PUBLISH.REPORTS, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default SendMessageSlice.reducer;
